module.exports = __webpack_public_path__ + "img/chess-queen.ac7687bc.svg";